import React from 'react';
import { Building2, ChevronDown, ChevronRight } from 'lucide-react';
import LocationNode from '@/components/settings/LocationNode';

export default function CompanyNode({
  company,
  locations = [],
  departmentsByLocation = {},
  expanded,
  onToggle,
  expandedLocations,
  autoExpandLocations = false,
  onToggleLocation,
  renderCompany,
  renderDepartment,
  renderLocation,
  compact = false,
}) {
  const departmentCount = locations.reduce((count, location) => count + (departmentsByLocation[location.id] || []).length, 0);

  return (
    <article className={`overflow-hidden border border-app-border bg-app-surface ${compact ? 'rounded-xl' : 'rounded-2xl'}`} data-testid={`settings-company-${company.id}`}>
      <div className={`flex flex-col bg-stone-50/70 ${compact ? 'gap-2 px-3 py-2.5' : 'gap-3 px-4 py-3 sm:px-5'}`}>
        <div className="flex min-w-0 items-start gap-2">
          <button
            type="button"
            className={`flex min-w-0 flex-1 text-left transition-colors hover:text-stone-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-emerald-200 ${compact ? 'items-center gap-2.5' : 'items-start gap-3'}`}
            aria-expanded={expanded}
            onClick={onToggle}
            data-testid={`settings-toggle-company-${company.id}`}
          >
            {expanded ? <ChevronDown className={`${compact ? '' : 'mt-1'} h-4 w-4 shrink-0 text-stone-400`} aria-hidden="true" /> : <ChevronRight className={`${compact ? '' : 'mt-1'} h-4 w-4 shrink-0 text-stone-400`} aria-hidden="true" />}
            <Building2 className={`${compact ? 'h-4 w-4' : 'mt-0.5 h-5 w-5'} shrink-0 text-brand-green`} aria-hidden="true" />
            <span className="min-w-0 flex-1">
              {!compact && <span className="block text-[10px] font-bold uppercase tracking-[0.18em] text-stone-500">Azienda</span>}
              <span className={`block break-words font-semibold text-brand-navy ${compact ? 'text-sm' : 'mt-0.5 font-display text-xl'}`}>{company.name}</span>
            </span>
            <span className={`shrink-0 text-right text-xs text-stone-400 ${compact ? '' : 'pt-1'}`}>
              {locations.length} {locations.length === 1 ? 'locale' : 'locali'}
              <span className="block">{departmentCount} {departmentCount === 1 ? 'reparto' : 'reparti'}</span>
            </span>
          </button>
        </div>
        {renderCompany?.({ company })}
      </div>
      {expanded && (
        locations.length ? (
          <div>
            {locations.map((location) => (
              <LocationNode
                key={location.id}
                company={company}
                location={location}
                departments={departmentsByLocation[location.id] || []}
                expanded={autoExpandLocations || expandedLocations.has(location.id)}
                onToggle={() => onToggleLocation(location.id)}
                renderDepartment={renderDepartment}
                renderLocation={renderLocation}
                compact={compact}
              />
            ))}
          </div>
        ) : (
          <div className="px-11 py-4 text-sm text-stone-500">Nessun locale disponibile.</div>
        )
      )}
    </article>
  );
}